import Para, { Environment } from '@getpara/react-sdk';

const para = new Para(Environment.PROD, process.env.REACT_APP_PARA_API_KEY);

export default para;
